import React, { Component } from 'react'
import { 
  Button, ButtonGroup, Popover,
  Menu, MenuItem, Position
} from '@blueprintjs/core';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

@inject('store', 'viewStore') @observer
class PricingParameterSearch extends Component {

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.pricingParameterSearch.page = 1;
    this.props.viewStore.pricingParameters();
  }

  @action
  onSearchTermChange(e) {
    
    let {
      props: {
        viewStore: {
          pricingParameterSearch
        }
      }
    } = this;
    this.props.viewStore.pricingParameterSearch = {
      ...pricingParameterSearch,
      term: e.target.value
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  render() {
    let {
      props: {
        viewStore,
        store,
        viewStore: {
          pricingParameterSearch: { term }
        }
      }
    } = this;
    if(term == '*'){
      term = '';
    }
    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
        actions={
          <Button icon={'plus'} small={true} onClick={() => viewStore.pricingParameterAdd()}>
            Add Pricing Parameter
          </Button>
        }
      >
        <input
          type="text"
          className="bp3-input search-filters-toolbar__field-wide"
          placeholder="Name"
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }
}

export default PricingParameterSearch;